import { isOrderStatusList, OrderStatus, OrderStatusLabel, Select, tokens, useOrderStatus } from 'ComponentLibrary'
import { keys } from 'lodash'
import { OrderFilterContainer } from '../sharedStyles'
import { Stack } from '@mui/material'
import { Checkbox } from 'ComponentLibrary/src/piazza/selectors'
import invariant from 'tiny-invariant'

type OrderStatusFilterProps = {
    setStatuses: (statuses: OrderStatus[]) => void
    statuses: OrderStatus[]
    inputLabel?: string
    statusLabels?: Partial<Record<OrderStatus, string>>
}

export function OrderStatusFilter({ setStatuses, statuses, inputLabel = 'Status', statusLabels }: OrderStatusFilterProps) {
    const { ORDER_STATUS_STATES, getOrderStatusText } = useOrderStatus()
    const getStatusLabel = (status: OrderStatus) => statusLabels?.[status] ?? getOrderStatusText(status)

    const handleChangeStatus = (status: string | string[]) => {
        const newStatusFilter = typeof status === 'string' ? status.split(',') : status
        invariant(isOrderStatusList(newStatusFilter), 'new status filter must be of type OrderStatus or OrderStatus[]')
        setStatuses(newStatusFilter)
    }
    const { temp_hide_in_portal: _, ...orderStatusOptions } = ORDER_STATUS_STATES

    return (
        <OrderFilterContainer>
            <Select
                fullWidth
                inputLabel={inputLabel}
                size="small"
                value={statuses}
                onChange={(e) => handleChangeStatus(e.target.value)}
                multiple
                options={keys(orderStatusOptions).map((key) => ({
                    value: key,
                    label: (
                        <Stack direction="row" gap={tokens.SizingSpacing050} alignItems="center" minWidth={0}>
                            <Checkbox checked={statuses.includes(key as OrderStatus)} />
                            <OrderStatusLabel status={key as OrderStatus} label={getStatusLabel(key as OrderStatus)} size="small" />
                        </Stack>
                    ),
                }))}
                selectProps={{
                    renderValue: (selected: string[]) => selected.map((s) => getStatusLabel(s as OrderStatus)).join(', '),
                    MenuProps: { PaperProps: { style: { marginTop: tokens.SizingSpacing100 } } },
                }}
                clear={() => setStatuses([])}
            />
        </OrderFilterContainer>
    )
}
